import React from "react";
import PropTypes from "prop-types";
import ExternalLayout from "../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../customComponents/RenderPage/RenderPage";
import Strip from "../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../customComponents/SEO/SEOComponent";
import application_contants from '../../contants/application_contants';
import HackBanner from "./Banner/HackBanner";
import Registers from "./Banner/RegisterButtons";
import About from "./Hack4ttsAbout";
import Challenge from "./Hack4ttsChallenge";
import Timeline from "./Hack4ttsTimeline";
import FinalEvent from "./Hack4ttsEvent";
import Participate from "./Hack4ttToParticipate";
import Evaluation from "./Hack4ttsEvaluation";
import Resources from "./Hack4ttsResources";
import Faqs from "./Hack4ttsFaqs";
import FooterHack4TTS from "./Hack4ttsFooter";
import HeaderTabs from './Banner/HackHeaderTabs';

const Hack4ttsInfo = (props) => {
  const [width] = useWindowSize();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ExternalLayout>
      <RenderPage
        id="tst-Hack4TTS"
        className={`render px-0 ${props.isClassName ? "render-page " : "min-height-auto"}`}
        containerType="container-fluid"
      >
        <SEOComponent
          title="Voice Tech for All"
          keywords="SYnthesizing SPeech in INdian languages"
          description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
          siteUrl="/Hack4TTS"
        />

        {/* <HackBanner /> */}

        {/* <img src={application_contants.hackbanner1280} className="banner1280" alt="banner-1280" />
        <img src={application_contants.hackbanner768} className="banner768" alt="banner-768" />
        <img src={application_contants.hackbanner360} className="banner360" alt="banner-360" /> */}
<picture>
  {/* ≥ 1280px */}
  <source
    media="(min-width: 1280px)"
    srcSet={application_contants.hackeventbannerlandscape}
  />
  {/* 768–1279px */}
  <source
    media="(min-width: 768px)"
    srcSet={application_contants.hackeventbannerlandscape}
  />
  {/* < 768px (fallback) */}
  <img
    src={application_contants.hackeventbanner768}
    alt="Hack4TTS banner"
    className="banner_size"
    loading="lazy"
    decoding="async"
  />
</picture>

        {/* <Strip id="tst-Hack4TTS" className="strip strip-no-padding" containerType="container-fluid"> */}
          {/* NEW: two-column shell */}
          <div className="vh-shell">
            {/* LEFT: fixed/sticky sidebar */}
            <HeaderTabs />

            {/* RIGHT: all content */}
            <div className="vh-main">
              <Registers />
              {/* <Registers section_id="register" /> */}
              <About section_id="about" />
              <Challenge section_id="challenge" />
              <Timeline section_id="timeline" />
              <FinalEvent section_id="finalevent" />
              <Participate section_id="participation" />
              <Evaluation section_id="evaluation" />
              <Resources section_id="resources" />
              <Faqs section_id="faqs" />
            </div>
          </div>
              <FooterHack4TTS section_id="footerhack4tts" />
        {/* </Strip> */}
      </RenderPage>
    </ExternalLayout>
  );
};

Hack4ttsInfo.defaultProps = { isClassName: true };
export default Hack4ttsInfo;